export const getters = {
  userInfo: (state) => state.userInfo, // 当前登录用户
  token: (state) => state.token, // 当前登录用户token
  tabsList: (state) => state.tabsList, // 底部tab页签列表
  TabsLeaveSite: (state) => state.TabsLeaveSite, // 底部table首页路由最后离开时滚动位置
}
